<loading *ngIf="loading">
  <ng-container i18n="@@front.resetPassword.loading">Loading your information</ng-container>
</loading>

<error *ngIf="error">
  <p>{{error}}</p>
  <a routerLink="/home" class="btn btn-primary" i18n="@@front.resetPassword.error.actionButton">Home Page</a>
</error>

<success *ngIf="success">
  <p i18n="@@front.resetPassword.success.message">Your password has been reset successfully</p>
  <a routerLink="/login" class="btn btn-front btn-lg btn-primary" i18n="@@front.resetPassword.success.actionButton">Login</a>
</success>

<div *ngIf="!loading && !success && !error">
  <div *ngIf="errorNotification" class="alert alert-warning">
    {{errorNotification}}
  </div>

  <form [formGroup]="form" (ngSubmit)="resetPassword()">
    <p *ngIf="isSMS()" class="text-center" i18n="@@front.resetPassword.smsDescription">an SMS code has been sent to {{phoneNumber}}, please enter the details below to reset your password</p>
    <p *ngIf="isTOTP()" class="text-center" i18n="@@front.resetPassword.totpDescription">Please fill out your TOTP code in the below form</p>

    <form-field *ngIf="isSMS()" class="front" label="SMS Code" i18n-label="@@front.resetPassword.smsCode.label">
      <input type="text" formControlName="otpCode" placeholder="Fill out the SMS Code" i18n-placeholder="@@front.resetPassword.smsCode.placeholder" autocomplete="one-time-code">
    </form-field>
    <form-field *ngIf="isTOTP()" class="front" label="TOTP Code" i18n-label="@@front.resetPassword.totpCode.label">
      <input type="text" formControlName="otpCode" placeholder="Fill out your TOTP Code" i18n-placeholder="@@front.resetPassword.totpCode.placeholder">
    </form-field>

    <password-complexity
      formControlName="password"
      label="New Password"
      placeholder="Enter your new password"
      i18n-label="@@front.resetPassword.passowrd.label"
      i18n-placeholder="@@front.resetPassword.password.placeholder"
    ></password-complexity>

    <div class="submit">
      <button type="submit" class="btn btn-front btn-lg btn-primary d-block w-100" [disabled]="!form.valid" i18n="@@front.resetPassword.submitButton">Reset Password</button>
    </div>
    <div class="text-center pt-3">
      <button *ngIf="!isNone() && isSmsEnabled()" class="btn btn-outline" (click)="sendSms()">
        <ng-container *ngIf="isSMS()" i18n="@@front.resetPassword.resendSms">Re-Send SMS code</ng-container>
        <ng-container *ngIf="isTOTP()" i18n="@@front.resetPassword.sendSmsInstead">Send an SMS instead</ng-container>
      </button>
    </div>
  </form>
</div>